export default{
    msg:'',
    editar:{},
    lista:'',
    boletim:''
}
